import React, {useState} from 'react'
import {LOCAL_STORAGE_KEY} from '../constants/localStorage';


function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process?.versions === 'object' && !!process?.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
}

const DebugContext = React.createContext()
DebugContext.displayName = 'DebugContext'

function DebugProvider(props) {
  const [isDebug, setIsDebug] = useState(false);

  React.useEffect(() => {
    if (isElectron()) {
      window.api?.receive("debugFromMain", (data) => {
        console.log('Received debug='+data+' in debugFromMain from Main process');
        if (data) {
          setIsDebug(true);
        }
      });
      // Send a message to the main process
      window.api?.send("syncToMain", "debug");
      console.log('sent toMain request to Main Process');
    }
    }, [])

  const value = React.useMemo(() => ({ isDebug }), [
    isDebug,
  ])
  return <DebugContext.Provider value={value} {...props} />
}

function useDebug() {
  const context = React.useContext(DebugContext)
  if (context === undefined) {
    throw new Error('useDebug must be used within a DebugProvider');
  }
  return context
}

export { DebugProvider, useDebug }